// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import type { JsonValueType } from '../inputTypeSchemas/JsonValueSchema';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { ScanStageInfoSchema } from './ScanStageInfoSchema'
import type { ScanStageInfo } from './ScanStageInfoSchema'
import { ActivityRunWithRelationsSchema } from './ActivityRunRelationsSchema'
import type { ActivityRunWithRelations } from './ActivityRunRelationsSchema'
import { ExternalNetworkScanSchema } from './ExternalNetworkScanSchema';

/////////////////////////////////////////
// EXTERNAL NETWORK SCAN RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkScanRelations = {
  surface: ExternalNetworkWithRelations;
  stages: ScanStageInfo[];
  activityRuns: ActivityRunWithRelations[];
};

export type ExternalNetworkScanWithRelations = Omit<z.infer<typeof ExternalNetworkScanSchema>, "chainRemaining" | "pendingTransitions"> & {
  chainRemaining?: JsonValueType | null;
  pendingTransitions?: JsonValueType | null;
} & ExternalNetworkScanRelations

export const ExternalNetworkScanWithRelationsSchema: z.ZodType<ExternalNetworkScanWithRelations> = ExternalNetworkScanSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  stages: z.lazy(() => ScanStageInfoSchema).array(),
  activityRuns: z.lazy(() => ActivityRunWithRelationsSchema).array(),
}))